import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import {
  FlexContainer,
  Heading1,
  Heading2,
  LI,
  Section,
  SectionArticle,
  UL,
  useLocales,
} from "@crescentapplications/react-ui";

export default function Education() {
  const l = useLocales();

  return (
    <Section bgColor="frame" id="education" padding="lg">
      <FlexContainer direction="column" gap="xl" fullWidth>
        <Heading1>{l(AhmadAhmadLocales.studies)}</Heading1>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.religiousEducation)}</Heading2>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.rE1A)}
              <a
                href="https://azharegypt.edu.eg"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {l(AhmadAhmadLocales.rE1Link)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.rE2A)}
              <a
                href="https://azharegypt.edu.eg"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {l(AhmadAhmadLocales.rE2Link)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>{l(AhmadAhmadLocales.rE3)}</LI>

            <LI>
              {l(AhmadAhmadLocales.rE4A)}
              <a
                href="https://bayanonline.org/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {l(AhmadAhmadLocales.rE4Link)}
              </a>
              {l(AhmadAhmadLocales.rE4B)}
            </LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.secularEducation)}</Heading2>
          <UL>
            <LI>
              {l(AhmadAhmadLocales.sE1A)}
              <a
                href="https://extension.berkeley.edu/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {l(AhmadAhmadLocales.sE1Link)}
              </a>{" "}
              {l(AhmadAhmadLocales.sE1B)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.sE2A)}
              <a href="https://www.cu.edu/" target="_blank" rel="noreferrer">
                {" "}
                {l(AhmadAhmadLocales.sE2Link)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.sE3A)}
              <a
                href="https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-secondary-2/cambridge-igcse/"
                target="_blank"
                rel="noreferrer"
              >
                <span className="english-font">(IGCSE)</span>
              </a>
              {l(AhmadAhmadLocales.sE3B)}
              <span className="english-font">Distinction</span>
              {l(AhmadAhmadLocales.sE3C)}
            </LI>

            <LI>
              {l(AhmadAhmadLocales.sE4A)}
              <a
                href="http://www.logic-consulting.com/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {l(AhmadAhmadLocales.sE4Link1)}
              </a>
              {l(AhmadAhmadLocales.comma)}{" "}
              <a href="http://aucegypt.edu/ar" target="_blank" rel="noreferrer">
                {l(AhmadAhmadLocales.sE4Link2)}
              </a>
              {l(AhmadAhmadLocales.comma)} {l(AhmadAhmadLocales.and)}
              <a href="http://uci.edu" target="_blank" rel="noreferrer">
                {l(AhmadAhmadLocales.sE4Link3)}
              </a>
              {l(AhmadAhmadLocales.period)}
            </LI>
          </UL>
        </SectionArticle>
      </FlexContainer>
    </Section>
  );
}
